(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["at-home-color"] && !window.DesignMode) return;
  try {
    
  
document.addEventListener("DOMContentLoaded", function() {
  var openPopupBtn = document.getElementById("open-video-popup");
  var videoPopup = document.getElementById("video-popup");
  var closePopupBtn = document.querySelector(".close-popup");
  var popupVideo = document.querySelector(".video-wrapper video"); // Select the video inside video_tag
  var playBtn = document.getElementById("play-video-btn");

  // Open popup on clicking the anchor
  openPopupBtn.addEventListener("click", function() {
    videoPopup.style.display = "block";
  });

  // Close popup when the close button is clicked
  closePopupBtn.addEventListener("click", function() {
    videoPopup.style.display = "none";
    popupVideo.pause(); // Pause the video when popup is closed
    playBtn.style.display = "block"; // Show play button again when the video stops
  });

  // Play video on clicking the play button
  playBtn.addEventListener("click", function() {
    popupVideo.play();
    playBtn.style.display = "none"; // Hide play button once the video starts
  });

  // Optional: Hide popup if the user clicks outside the video container
  window.addEventListener("click", function(event) {
    if (event.target == videoPopup) {
      videoPopup.style.display = "none";
      popupVideo.pause();
      playBtn.style.display = "block"; // Show play button again when popup closes
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  console.log(productRecommendationsSection);
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
  };
  // fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
